import React, { lazy, Suspense } from 'react';

const LazyAdminInventory = lazy(() => import('./AdminInventory'));

const AdminInventory = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyAdminInventory {...props} />
  </Suspense>
);

export default AdminInventory;
